<template>
  <div class="app">
    <AppSideNav
        class="app__nav"
        :links="pages"
        @click="setLink"
        :current="view"
    />
    <div class="app__main">
        <AppHeader
            class="app__header"
            :page="view.text"
        />

        <div class="app__views">
            <transition name="fade" mode="out-in">
                <router-view class="view"></router-view>
            </transition>
        </div>
    </div>

    <AppPopup
        :visible="modalName.includes('confirm')"
        type="warning"
        :title="modalTitle"
        :modalDesc="modalDesc"
        message="Your input will be lost."
        @close="$store.commit('closeSpecificModal', { modalName: 'confirm' })"
    >
        <AppButton @click="$store.dispatch('confirm')" modifier="small-primary">Ok</AppButton>
        <AppButton @click="$store.commit('closeSpecificModal', { modalName: 'confirm' })" modifier="small-danger">Cancel</AppButton>
    </AppPopup>

    <AppBanner v-if="bannerStatus"/>

  </div>
</template>

<script>
import AppBanner from '@/components/AppBanner'
import AppPopup from '@/components/AppPopup'
import AppButton from '@/components/AppButton'
import AppSideNav from '@/components/AppSideNav'
import AppHeader from '@/components/AppHeader'
import { mapGetters } from 'vuex'

export default {
	data () {
		return {
			pages: [
				{ name: 'SongsList', text: 'Songs', children: [] },
				{ name: 'SubscribersList', text: 'Subscribers', children: [] },
				// { name: 'SubscriptionsList', text: 'Subscriptions', children: [] },
				{ name: 'BindingAccountsList', text: 'Binding Accounts', children: [] },
				{ name: 'ThemesList', text: 'Themes', children: [] },
				{ name: 'SubscriberPlansList', text: 'Subscriber Plans', children: ['SubscriberPlansCreate', 'SubscriberPlansEdit'] }
			],
			view: { name: 'SongsList', text: 'Songs' }
		}
	},
	methods: {
		setLink (e) {
			this.view = e
			this.$router.push({ name: e.name })
		}
	},
	created () {
		this.view = this.pages.find(route => route.name === this.$route.name || route.children.includes(this.$route.name))
	},
	computed: {
		...mapGetters({
			bannerStatus: 'getBannerStatus',
			modalName: 'modalName',
			modalDesc: 'modalDesc',
			modalTitle: 'modalTitle'
		})
	},
	components: {
		AppSideNav,
		AppHeader,
		AppPopup,
		AppBanner,
		AppButton
	}
}
</script>

<style lang="scss" scoped>
.app {
    color: $default;
	height: 100vh;
	width: 100vw;
	overflow: hidden;
    display: flex;

	&__main {
		flex: 1 1 auto;
		display: flex;
		flex-direction: column;
		overflow: hidden;
	}

	&__nav {
		flex-shrink: 0;
	}

	&__views {
		flex: 1 1 auto;
		overflow: auto;
		background-color: #F5F6F8;

		.view {
			height: 100%;
			width: 100%;
			min-width: 850px;
		}
	}
}
</style>
